import React from "react";
import "./Development.css";
import Container from "react-bootstrap/Container";
import Background from "../../Background/Background";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileContract,
  faHandHoldingDollar,
  faLock,
  faCircleInfo,
  faListCheck,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const helpItems = [
  {
    title: "Cómo contratar nuestros servicios",
    description:
      "Conocé el proceso para solicitar una cotización, aceptar una propuesta, realizar el pago y comenzar un proyecto con VPEX.",
    path: "/como-contratar",
    icon: faListCheck,
  },
  {
    title: "Términos y Condiciones",
    description:
      "Condiciones aplicables a desarrollos personalizados, servicios de infraestructura, productos digitales, pagos, entregas y soporte.",
    path: "/terminos-y-condiciones",
    icon: faFileContract,
  },
  {
    title: "Política de cancelaciones y reembolsos",
    description:
      "Información sobre cancelaciones, anticipos, trabajos ya iniciados, suscripciones y solicitudes de devolución.",
    path: "/politica-de-reembolsos",
    icon: faHandHoldingDollar,
  },
  {
    title: "Política de Privacidad",
    description:
      "Cómo recopilamos, utilizamos y protegemos los datos enviados mediante nuestros formularios y canales de contacto.",
    path: "/politica-de-privacidad",
    icon: faLock,
  },
  {
    title: "Información legal",
    description:
      "Datos del responsable del sitio, identificación, país de operación y medios oficiales de contacto de VPEX.",
    path: "/informacion-legal",
    icon: faCircleInfo,
  },
];

const FAQ = () => {
  return (
    <>
      <Background />
      <main className="help-page">
        <Container className="help-container">
          <header className="help-header text-center">
            <h1 className="txt-h2-d fw-bold title-d">Ayuda</h1>
            <p>
              Encontrá aquí la información necesaria para contratar nuestros
              servicios, conocer sus condiciones y comunicarte con VPEX.
            </p>
          </header>

          <section className="help-list" aria-label="Información de ayuda y políticas">
            {helpItems.map((item) => (
              <Link className="help-item" to={item.path} key={item.path}>
                <span className="help-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={item.icon} />
                </span>
                <span className="help-content">
                  <strong>{item.title}</strong>
                  <span>{item.description}</span>
                </span>
                <span className="help-arrow" aria-hidden="true">→</span>
              </Link>
            ))}
          </section>

          <section className="help-contact" aria-labelledby="help-contact-title">
            <h2 id="help-contact-title">¿Necesitás comunicarte con nosotros?</h2>
            <p>
              Podés escribirnos para realizar una consulta, solicitar una
              cotización o ejercer tus derechos sobre tus datos personales.
            </p>
            <div className="help-contact-links">
              <a href="mailto:valvarez@vpex.com.uy">
                <FontAwesomeIcon icon={faEnvelope} />
                valvarez@vpex.com.uy
              </a>
              <a href="https://wa.me/59899447449" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faPhone} />
                +598 99 447 449
              </a>
            </div>
          </section>
        </Container>
      </main>
    </>
  );
};

export default FAQ;
